import parse from 'html-react-parser';

export const ShowAsHTML = (text: string) => parse(text);

export const stringTimeToUnix = (time: string) => {
    const unixTimeMs: number = new Date(time).getTime();
    // Convert to Unix timestamp (seconds)
    return Math.floor(unixTimeMs / 1000);
}